import React, { useContext, useEffect, useState } from 'react'
import { FaPlus } from 'react-icons/fa'
import { FaGear } from 'react-icons/fa6'
import { TbLoader2 } from 'react-icons/tb'
import { Link, useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import { BASE_URL_API } from '../../References/URLs'
import ActiveStoreContext from '../../store/ActiveStoreContext'
import AuthContext from '../../store/auth-context'
import styles from './MembershipSettings.module.css'
import Select from 'react-select'
import EnableForm from '../../Components/MiniSite/EnableForm'

const cardTypeOptions = [
    // { value: 'TRULY_UNLIMITED', label: 'Truly Unlimited' },
    { value: 'VALUE_ADDITION', label: 'Value Addition' },
    // { value: 'EXTRA_DISCOUNT', label: 'Extra Discount' },
    // { value: 'CUSTOM', label: 'CUSTOM' }
]

const MembershipSettings = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext)
    const activeStore = (() => { try { return asCtx?.activeStore && asCtx.activeStore.trim() !== "" ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier
    const nav = useNavigate()

    const [activeAction, setActiveAction] = useState(null)
    const [name, setName] = useState('')
    const [isCreating, setIsCreating] = useState(false)
    const [createdMemberships, setCreatedMemberships] = useState([])
    const [isFetching, setIsFetching] = useState(false)
    const [cardType, setCardType] = useState('')
    const [membershipCategory, setMembershipCategory] = useState('')
    const [miniSiteStatus, setMiniSiteStatus] = useState(false)
    const [enablePopUpOpen, setEnablePopUpOpen] = useState(false)
    const [isValidating, setIsValidating] = useState(false)

    const [categories, setCategories] = useState([])

    const createMembership = async () => {
        if (name === '') { alert(`Kindly give it a name!`); return }
        if (cardType === '') { alert('Kindly select Type of Card'); return }
        if (membershipCategory === '') { alert('Kindly select Membership Tier / Category of Card'); return }
        setIsCreating(true)
        const response = await fetch(BASE_URL_API + "createMembership",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore?.storeIdentifier,
                    vendorIdentifier: vendorIdentifier,
                    authIdentifier: authCtx?.authIdentifier,
                    name: name,
                    cardTypeLabel: cardType?.label,
                    cardTypeIdentifier: cardType?.value,
                    categoryTypeLabel: membershipCategory?.label,
                    categoryTypeIdentifier: membershipCategory?.value
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                toast(respo?.message)
                nav(`/memberships/settings/${respo?.response?.membershipIdentifier}/general-details`)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                } else {
                    toast(respo?.message)
                }
            }
            console.log(respo)
        }
        setIsCreating(false)
    }

    const getMemberships = async () => {
        setIsFetching(true)
        const response = await fetch(BASE_URL_API + "getMemberships",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore?.storeIdentifier,
                    vendorIdentifier: vendorIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                setCreatedMemberships(respo?.response)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                } else {
                    setCreatedMemberships([])
                }
            }
            console.log(respo)
        }
        setIsFetching(false)
    }

    useEffect(() => {
        getMemberships()
    }, [])

    const getMembershipCategories = async () => {
        const response = await fetch(BASE_URL_API + "getMembershipCategories",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                const transformed = respo?.response?.map(item => ({
                    value: item.code,
                    label: `${item?.name} - (${item?.code})`  // just the name
                }));
                setCategories(transformed);
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                }
            }

            console.log(respo)
        }

    }

    useEffect(() => {
        getMembershipCategories()
    }, [])

    const cancelCreationHandler = () => {
        setActiveAction(null)
        setIsCreating(false)
    }

    const validateMiniSiteActivation = async () => {
        setIsValidating(true)
        const response = await fetch(BASE_URL_API + "validateMiniSiteActivation",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    storeIdentifier: activeStore?.storeIdentifier
                })
            });
        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                if (respo?.response === "enabled") {
                    setMiniSiteStatus(true)
                } else {
                    setMiniSiteStatus(false)
                }
            } else {
                if (!respo?.message === "tokenExpired") {
                    authCtx.logout()
                }
                setMiniSiteStatus(false)
            }
        }
        setIsValidating(false)
    }

    useEffect(() => {
        if (activeStore !== null) {
            validateMiniSiteActivation()
        }
    }, [])

    const handlePopupClosure = () => {
        setEnablePopUpOpen()
        validateMiniSiteActivation()
    }


    if (activeStore === null) {
        return (
            <div>
                Please select a store first!
            </div>
        )
    }

    if (miniSiteStatus === false) {
        return (
            <>
                {isValidating === false ?
                    <div className={styles.mainWrapperMinisite} >
                        {enablePopUpOpen === true && <EnableForm onClose={handlePopupClosure} />}
                        <div className={styles.txtEnable}>
                            You must enable Mini site to create a membership.
                        </div>
                        <div>
                            <button className={styles.enableBtn} onClick={() => setEnablePopUpOpen(true)} >Enable Now</button>
                        </div>
                    </div>
                    :
                    <div className={styles.mainWrapperMinisite} >
                        <div className={styles.txtEnable}>
                            Hold On!
                        </div>
                        <div className={styles.txtEnable}>
                            Loading configurations...
                        </div>
                    </div>
                }
            </>
        )
    }

    return (
        <div className={styles.mainWrapper} >
            {activeAction === null ?
                <div className={styles.mainContainer}>
                    <div className={styles.pageTitle}>
                        Membership Settings
                    </div>
                    <div className={styles.mainContent}>
                        <div className={styles.eachTile} onClick={() => setActiveAction('new')} >
                            <FaPlus size={26} color="#408DFB" />
                            Create New Card
                        </div>
                        <div className={styles.eachTile} onClick={() => setActiveAction('old')} >
                            <FaGear size={26} color="#408DFB" />
                            Configure A Card
                        </div>
                    </div>
                </div>
                :
                <div>
                    {activeAction === "new" &&
                        <div className={styles.mainContainer}>
                            <div className={styles.pageTitle}>
                                Create A New Card
                            </div>
                            <div className={styles.mainContent}>
                                <div className={styles.formWrapper}>
                                    <div className={styles.inputWrapper} >
                                        <input
                                            readOnly={isCreating}
                                            autoFocus={true}
                                            className={styles.nameInput} value={name}
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                    </div>

                                    <div className={styles.formGroup}>
                                        <label className={styles.label}>
                                            Type of Card
                                        </label>
                                        <Select
                                            className={styles.reactSelect}
                                            options={cardTypeOptions}
                                            placeholder="Select Card Type"
                                            value={cardType}
                                            onChange={(selected) => setCardType(selected)}
                                            isSearchable
                                        />
                                    </div>

                                    <div className={styles.formGroup}>
                                        <label className={styles.label}>
                                            Membership Category
                                        </label>
                                        <Select
                                            className={styles.reactSelect}
                                            options={categories}
                                            placeholder="Select Membership Categories"
                                            value={membershipCategory}
                                            onChange={(selected) => setMembershipCategory(selected)}
                                            isSearchable
                                        />
                                    </div>


                                    <div className={styles.actionWrapper} >
                                        <button onClick={() => cancelCreationHandler()} disabled={isCreating} className={styles.cancelBtn} >Cancel</button>
                                        {isCreating === true ?
                                            <button className={styles.createBtn} ><TbLoader2 size={16} className={styles.spinner} />Creating... </button>
                                            :
                                            <button className={styles.createBtn} onClick={() => createMembership()} >Create</button>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {activeAction === "old" &&
                        <div className={styles.mainContainer}>
                            <div className={styles.pageTitle}>
                                Configure A Card
                            </div>
                            <div className={styles.mainContent}>
                                <div className={styles.cardsListWrapper} >
                                    <div className={styles.listHeader} >
                                        <div className={styles.sn} >#</div>
                                        <div className={styles.name} >Name</div>
                                        <div className={styles.activeSince} >Active Since</div>
                                        <div className={styles.members} >Members</div>
                                        <div className={styles.action} >Action</div>
                                    </div>
                                    {createdMemberships?.length > 0 ?
                                        <div className={styles.listWrapper} >
                                            {createdMemberships?.map((item, index) => (
                                                <div key={index} className={styles.eachRow} >
                                                    <div className={styles.sn} >{index + 1}</div>
                                                    <div className={styles.name} >{item?.name}</div>
                                                    <div className={styles.activeSince} >
                                                        {item?.createdOn}
                                                    </div>
                                                    <div className={styles.members} >{item?.totalMembers}</div>
                                                    <div className={styles.action} >
                                                        <Link className={styles.configureBtn} to={`/memberships/settings/${item?.membershipIdentifier}/general-details`}>Configure</Link>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        :
                                        <div className={styles.notFound} >
                                            <div className={styles.notFoundTxt}>
                                                You haven't created any memberships yet!
                                            </div>
                                            <div className={styles.actionWrapperNf} >
                                                <button className={styles.createBtn} onClick={() => setActiveAction('new')} >Create Now</button>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    )
}

export default MembershipSettings